module.exports = __webpack_public_path__ + "img/anonymous.888afd49.svg";